import RegistryEntryCard, { type RegistryEntryConfig } from '../../../components/registry/RegistryEntryCard';
import { DERMATO_PHASES, computePhaseStatuses } from './phases';

const config: RegistryEntryConfig = {
  program: 'DERMATO',
  title: 'Fișă de registru dermato',
  buttonLabel: 'Deschide spațiul de lucru dermato',
  buttonTestId: 'open-dermato-workspace',
  routeSegment: 'dermato',
  phases: DERMATO_PHASES,
  computeStatuses: computePhaseStatuses,
  flowDescription: 'Datele importate din documente sunt organizate pe cele 4 faze ale fluxului medical:',
};

/**
 * Cartela compactă din fișa pacientului pentru registrul dermato importat:
 * sumar pe faze + link spre spațiul de lucru (/patients/:id/dermato/faza-1).
 */
export default function DermatoRegistryEntry({ patientId }: { patientId: string }) {
  return <RegistryEntryCard config={config} patientId={patientId} />;
}
